export default "__VITE_ASSET__CUm0n2RS__"